// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__UpBag","productName":"Table_productName__2Vg-B"};